// DISTANCE UNIT
export const GET_DISTANCE_UNITS = '/distance_unit/query';
export const GET_DISTANCE_UNIT = '/distance_unit/';
export const POST_DISTANCE_UNIT = '/distance_unit/';
export const PUT_DISTANCE_UNIT = '/distance_unit/';
export const DELETE_DISTANCE_UNIT = '/distance_unit/';
export const CHECK_DISTANCE_UNIT_EXISTS = '/distance_unit/query';
